/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { InKeyTypeValuesItem } from './InKeyTypeValuesItem';

export const InKeyType: core.serialization.ObjectSchema<serializers.InKeyType.Raw, Truvity.InKeyType> =
    core.serialization.object({
        values: core.serialization.list(InKeyTypeValuesItem),
    });

export declare namespace InKeyType {
    export interface Raw {
        values: InKeyTypeValuesItem.Raw[];
    }
}
